import { LOGIN, LOGOUT, SET_USER_LOADED } from "../actions/types";

const initialState = {
  userData: {},
  userLoaded: false,
  loadError: false
};

export function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        userData: action.userData || {}
      };
    case SET_USER_LOADED:
      return {
        ...state,
        userLoaded: action.bool
      };
    case LOGOUT:
      return {
        ...state,
        userData: {}
      };
    default:
      return state;
  }
}
